// Composition root: the one place that wires concrete deep-dive widgets
// into the registry. Add a new one with an import + list entry.
import { registerDeepDiveApp } from '@/core/deep-dive/export';
import { forecastFrenzyWidget, hscWidget } from '@/modules/calendar/export';
import { pipelineMapWidget } from '@/modules/pipelines/export';
import { bookmarksWidget } from '@/modules/articles/export';

[forecastFrenzyWidget, pipelineMapWidget, hscWidget].forEach(widget => registerDeepDiveApp(widget));
registerDeepDiveApp(bookmarksWidget, { requireDeepDiveAccess: false });
